module.exports = require("vue-select");